import { useState } from "react";
import { convertToUTCString } from "./helper";

const formatDateOnly = (dateString) => {
  const date = new Date(dateString);
  return date.toISOString().split("T")[0]; // Extracts only the YYYY-MM-DD part
};

export const customMuiDateFilter = [
  {
    label: "Contains",
    value: "contains",
    getApplyFilterFn: (filterItem) => {
      if (!filterItem?.value) return null;

      return (params) => {
        if (!params) return false;

        const formattedDate = formatDateOnly(params); // Extracts only date part
        const filterDate = formatDateOnly(filterItem.value); // Extracts only date part

        return formattedDate.includes(filterDate);
      };
    },
    InputComponent: ({ item, applyValue }) => {
      const [inputValue, setInputValue] = useState(item?.value || "");

      const handleChange = (e) => {
        const newValue = e.target.value;
        setInputValue(newValue);
        applyValue({ ...item, value: newValue }); // Apply filter with new date value
      };

      return (
        <form className="form-floating">
          <input
            type="date"
            value={inputValue}
            onChange={handleChange}
            placeholder="Select Date..."
            className="form-control border-0 pb-0 no-shadow rounded-0 text-capitalize"
            id="floatingInputValue"
          />
          <label htmlFor="floatingInputValue">Select Date</label>
        </form>
      );
    },
  },
  {
    label: "Equals",
    value: "equals",
    getApplyFilterFn: (filterItem) => {
      if (!filterItem?.value) return null;

      return (params) => {
        const formattedDate = params
          ? convertToUTCString(params).toLowerCase()
          : "";

        return formattedDate.includes(filterItem.value.toLowerCase());
      };
    },
    InputComponent: ({ item, applyValue }) => {
      const [inputValue, setInputValue] = useState(item?.value || "");

      const handleChange = (e) => {
        const newValue = e.target.value;
        setInputValue(newValue);
        applyValue({ ...item, value: newValue }); // This updates the filter value
      };

      return (
        <form className="form-floating">
          <input
            type="search"
            value={inputValue}
            onChange={handleChange}
            placeholder="Search Date..."
            className="form-control border-0 pb-0 no-shadow rounded-0 text-capitalize"
            id="floatingInputValue"
          />
          <label htmlFor="floatingInputValue" className="">
            Value
          </label>
        </form>
      );
    },
  },
];
